import { localStorageKeyPrefix } from '@previo/core'

enum LocalStorageKeys {
  AUTHORIZATION = 'authorization',
  DEVICE_UD = 'device-id',
  CALENDAR_VIEW_PRESETS = 'calendar_view_presets',
  CODEBOOKS = 'codebooks',
  COMPANY_TAGS = 'company-tags',
  MARKET_CODES = 'market-codes',
  GUEST_TAGS = 'guest-tags',
  COUNTRY_INVOICE_FIELDS = 'country-invoice-fields',
  COMPANY_DATA_FROM_ARES = 'company-data-from-ares',
  USER = 'user',
  LAST_SELECTED_PROPERTY_ID = 'last_selected_property_id',
  CALENDAR_VIEW_SETTINGS = 'calendar_view_settings',
  CALENDAR_SIDE_PANEL_EXPANDED = 'calendar_side_panel_expanded',
  CALENDAR_COLUMN_WIDTH = 'calendar_column_width',
  CALENDARS_SIZES_SETTINGS = 'calendars_sizes_settings',
  RESERVATION_SOURCES = 'reservation_sources',
  PROPERTY_MARKET_CODES = 'property_market_codes',
  VAT_CLASSIFICATIONS = 'vat-classifications',
  ACCOUNT_ASSIGNMENTS = 'account-assignments',
  SERVICE_CLASSIFICATIONS = 'service-classifications',
  GTU_CODES = 'gtu-codes',
  USES_BETA_VERSION = 'uses_beta_version',
  PRINT_GUEST_CARD = 'print_guest_card_settings',
  PAYMENT_PRESCRIPTION = 'payment_prescription_settings',
  DASHBOARD_TUTORIAL_OPEN = 'dashboard_tutorial_open',
  RESERVATION_PLUS_CONFIGURATOR_TUTORIAL_OPEN = 'reservation_plus_configurator_tutorial_open',
  RAN_MIGRATIONS = 'ran_migrations',
  FOLIO_ITEMS_EXPANDED = 'folio-items_expanded',
  FOLIO_DOCUMENTS_EXPANDED = 'folio-documents_expanded',
  DOCUMENTS_VAT_DATE_WARNING_HIDDEN = 'vat-date-warning-dont-show-again',
  GUEST_DUPLICITY_DISMISS_CONFIRM_HIDDEN = 'guest-duplicity-dismiss-confirm-dont-show-again',
  CHUNK_LOAD_RELOAD = 'chunk_load_reload',
}

class LocalStorageKeyManager {
  private static prefix = localStorageKeyPrefix()

  static createStorageKey(key: LocalStorageKeys): string {
    return this.prefix + key
  }
}

export { LocalStorageKeys, LocalStorageKeyManager }
